import React from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

/**
 * Shared page wrapper for consistent horizontal centering + padding.
 * Keep it lightweight so we can adopt it incrementally across pages.
 */
export default function PageShell({ children, maxWidth = "lg" }) {
  return (
    <Container maxWidth={maxWidth} disableGutters={false}>
      <Box
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Container>
  );
}

PageShell.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]),
};

